export type CountryString = string | Country;

export enum Country {
  Australia = 'AUS',
  UnitedStates = 'USA',
  NewZealand = 'NZL',
  GreatBritain = 'GBR',
  Canada = 'CAN',
  Germany = 'DEU',
  Austria = 'AUT',
  France = 'FRA',
  India = 'IND',
  Singapore = 'SGP',
  Malaysia = 'MYS',
  HongKong = 'HKG',
}
